import React from "react";
import { profileImgPlaceholder } from "../../../../assets/images";
import { Domain, request } from "../../../../config/API";
import { COLORS } from "../../../../config/theme";
import MainIconBar from "../MainIconBar";
import InfoBox from "../InfoBox";
import { ReactComponent as Vector } from "./Vector1.svg";
import { Col, Row } from "antd";
import SocialIconBar from "../SocialIconBar";
const Theme3 = ({ vCard, isPreview, downloadVcfFile, setShowExchangeCard }) => {
  const { primaryColor } = COLORS;
  const {
    fNamePrefix,
    fName,
    lName,
    lNameSuffix,
    email,
    company,
    jobTitle,
    mobile,
    address,
    bgImage,
    profileImage,
    pColor,
    sColor,
    socialLinks,
    leadEnable,
    owner,
    webLinks,
  } = vCard;
  const handleLinkClicked = (type) => {
    const data = { type, portalId: owner };
    request
      .post("qr/postLinkClicked", data)
      .then(async (res) => {})
      .catch((e) => {
        console.log("post click error=>", e);
      });
  };
  return (
    <Col style={{ width: "100%", backgroundColor: sColor }}>
      <Col
        style={{
          position: "relative",
          background: `linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0,0, 0.8)),
      ${bgImage ? `url(${Domain}/data/${bgImage})` : pColor}`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          overflow: "hidden",
          backgroundPosition: "center",
          height: "460px",
        }}
      >
        <Row
          style={{
            position: "absolute",
            bottom: "-7px",
            left: "-4px",
          }}
        >
          <Vector fill={sColor} />
        </Row>
        <Row
          span={24}
          style={{
            position: "absolute",
            display: "flex",
            width: "100%",
            bottom: 100,
          }}
        >
          <Col span={12}>
            <Row
              style={{
                display: "flex",
              }}
            >
              <img
                draggable={false}
                style={{
                  height: "7rem",
                  width: "7rem",
                  borderRadius: "1rem",
                  zIndex: 99,
                  marginBottom: 30,
                  marginLeft: 25,
                }}
                src={
                  profileImage
                    ? `${Domain}/data/${profileImage}`
                    : profileImgPlaceholder
                }
                alt=""
              />
            </Row>
            <Row>
              <MainIconBar
                mobile={mobile}
                email={email}
                address={address}
                sColor={sColor}
                horizontal={true}
              />
            </Row>
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <InfoBox
              fName={fName}
              jobTitle={jobTitle}
              company={company}
              black={false}
            />
          </Col>
        </Row>
      </Col>
      <SocialIconBar
        socialLinks={socialLinks}
        leadEnable={leadEnable}
        sColor={sColor}
        downloadVcfFile={downloadVcfFile}
        setShowExchangeCard={setShowExchangeCard}
        owner={owner}
        isBlack={false}
        webLinks={webLinks}
        isPreview={isPreview}
      />
    </Col>
  );
};

export default Theme3;
